import React from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";
// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";
import { IInvoicesItem } from "src/common/typings/invoices";
import { getLocalDateTime } from "src/common/utils/app.util";
import { moneyformatter } from "src/common/utils/helpers";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    marginLabelHeading: {
      fontWeight: theme.typography.fontWeightRegular,
      color: "rgba(0, 0, 0, 0.54)",
      //lineHeight: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(17),
      color: "#000",
      lineHeight: "28px",
    },
    marginLabelText: {
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      //lineHeight: "20px",
    },
  })
);

type Props = {
  stickyInfo: IInvoicesItem;
  relateInvoiceData: any[];
};

export function Sticky({ stickyInfo, relateInvoiceData }: Props): React.ReactElement {
  const classes = useStyles();
  return (
    <>
      <Grid container direction="row">
        <Grid item xs={12} md={12}>
          <Box ml={0}>
            <Grid item xs={12} md={12}>
              <Box mt={2}>
                <Typography className={classes.heading}>Invoice Details</Typography>
              </Box>
            </Grid>
            <Divider />
            <Box p={2} mb={3}>
              <Grid container direction="row">
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={5}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>Invoice #:</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={7}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {stickyInfo?.invoiceNum || ""}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={5}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>Invoice Amt:</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={7}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {moneyformatter(stickyInfo?.invoiceAmt)}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={5}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>Check #:</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={7}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {stickyInfo?.checkNo || ""}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={5}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>
                          Received Date:
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={7}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {getLocalDateTime(stickyInfo?.recievedDate, "MM/DD/YYYY")}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={5}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>
                          Release Date:
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={7}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {getLocalDateTime(stickyInfo?.releaseDate, "MM/DD/YYYY")}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={5}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>
                          Expected Date:
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={7}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {getLocalDateTime(stickyInfo?.expectedDate, "MM/DD/YYYY")}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid item xs={12} md={12}>
          <Box ml={0}>
            <Grid item xs={12} md={12}>
              <Box mt={2}>
                <Typography className={classes.heading}> Related Orders</Typography>
              </Box>
            </Grid>
            <Divider />
            <Box p={2} mb={3}>
              {relateInvoiceData.length > 0 && (
                <Grid container direction="row">
                  <Grid item xs={4} md={4}>
                    <Box color="text.secondary">
                      <Typography className={classes.marginLabelHeading}>Company</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={2} md={2}>
                    <Box color="text.secondary">
                      <Typography className={classes.marginLabelHeading}>PO #</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={2} md={2}>
                    <Box color="text.secondary">
                      <Typography className={classes.marginLabelHeading}>Loc ID</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={2} md={2}>
                    <Box color="text.secondary">
                      <Typography className={classes.marginLabelHeading}>Bill Amt</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={2} md={2}>
                    <Box color="text.secondary">
                      <Typography className={classes.marginLabelHeading}>Pay Amt</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Box mt={1} mb={1}>
                      <Divider />
                    </Box>
                  </Grid>
                  {relateInvoiceData.map((itemData) => {
                    return (
                      <>
                        <Grid item xs={4} md={4} key={itemData.id}>
                          <Box color="text.secondary">
                            <Typography className={classes.marginLabelText}>
                              {itemData.company}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={2} md={2} key={itemData.id}>
                          <Box color="text.secondary">
                            <Typography className={classes.marginLabelText}>
                              {itemData.poNum}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={2} md={2} key={itemData.id}>
                          <Box color="text.secondary">
                            <Typography className={classes.marginLabelText}>
                              {itemData.locationId}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={2} md={2} key={itemData.id}>
                          <Box color="text.secondary">
                            <Typography className={classes.marginLabelText}>
                              {moneyformatter(itemData.billAmt)}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={2} md={2} key={itemData.id}>
                          <Box color="text.secondary">
                            <Typography className={classes.marginLabelText}>
                              {moneyformatter(itemData.payAmt)}
                            </Typography>
                          </Box>
                        </Grid>
                      </>
                    );
                  })}
                  <Grid item xs={12} md={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={8} md={6}></Grid>
                  <Grid item xs={2} md={2}>
                    <Box color="text.secondary" display="flex" justifyContent={"flex-start"}>
                      <Typography className={classes.marginLabelText}>Sum</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={2} md={2}>
                    <Box color="text.secondary" display="flex" justifyContent={"flex-start"}>
                      <Typography className={classes.marginLabelText}>
                        {`${moneyformatter(
                          relateInvoiceData?.reduce(
                            (acc, currentValue) => acc + currentValue.billAmt,
                            0
                          )
                        )}`}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={2} md={2}>
                    <Box color="text.secondary" display="flex" justifyContent={"flex-start"}>
                      <Typography className={classes.marginLabelText}>
                        {" "}
                        {`${moneyformatter(
                          relateInvoiceData?.reduce(
                            (acc, currentValue) => acc + currentValue.payAmt,
                            0
                          )
                        )}`}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
